import { Switch, Route, useRouteMatch } from 'react-router-dom';
import { PageLoading } from '@/app/ui/page';
import LoadComponentWithRetry from '@/app/routes/LoadComponentWithRetry';

const ViewComponent = LoadComponentWithRetry(() => import('./ViewAccountSetupPage'), <PageLoading variant="app" />);

const Routes = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={`${path}/:uid`} component={ViewComponent} />
    </Switch>
  );
};

export default Routes;
